import React, { ComponentProps as CP } from 'react'
import Button from 'components/Button'
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'
import kickerLogo from './assets/logo_kicker.svg'

type Props = CP<typeof Button>

const styles = createStyles({
  root: {
    color: 'white',
    borderColor: '#E20317',
    backgroundColor: '#E20317',

    '&:hover': {
      backgroundColor: '#AC000F'
    }
  },
  children: {
    width: 0,
    opacity: 0
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const KickerButton: React.SFC<InjectedProps> = ({ children, classes, ...props }) => {
  return (
    <Button {...props} className={classes.root}>
      <img alt="" src={kickerLogo} />
      <span className={classes.children}>{children}</span>
    </Button>
  )
}

export default withStyles(styles)(KickerButton)
